/**
 * TanStack Query hooks for `dpa-template-on-request`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dpaTemplateOnRequestQueryKeys,
	type CreateDpaTemplateOnRequestBody,
	type ListDpaTemplateOnRequestResponse,
	type DpaTemplateOnRequestRow,
} from "./api";

export function useDpaTemplateOnRequestList(): UseQueryResult<ListDpaTemplateOnRequestResponse, Error> {
	return useQuery({
		queryKey: dpaTemplateOnRequestQueryKeys.list(),
		queryFn: list,
	});
}

export function useDpaTemplateOnRequestCreate(): UseMutationResult<DpaTemplateOnRequestRow, Error, CreateDpaTemplateOnRequestBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpaTemplateOnRequestQueryKeys.all });
		},
	});
}

export function useDpaTemplateOnRequestDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpaTemplateOnRequestQueryKeys.all });
		},
	});
}
